document.addEventListener("DOMContentLoaded", function () {
    const closeBtn = document.querySelector(".close-btn");
    closeBtn.addEventListener("click", function () {
        const drawer = document.querySelector("#Details-menu-drawer-container");
        //remove el atributo open
        drawer.removeAttribute("open");
        //remueve la clase menu-opening
        drawer.classList.remove("menu-opening");
        //summary aria-expanded = false
        const summary = drawer.querySelector("summary");
        summary.setAttribute("aria-expanded", "false");
        //remove class overflow-hidden-tablet de body
        document.body.classList.remove("overflow-hidden-tablet");

        //de .shopify-section-header-sticky remueve la clase menu-open
        const headerSticky = document.querySelector(".shopify-section-header-sticky");
        headerSticky.classList.remove("menu-open");
    });
});